module.exports = __webpack_public_path__ + "img/gnu_gallery4.0e884188.jpg";